<template>
  <div>
    <CommonHead></CommonHead>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Forgot Password"
      title-tag="h3"
      title-class="reset_title"
      ok-only
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      modal-class="common_pop forget_pop"
    >
      <form class="commonform" ref="form" @submit.stop.prevent="handleSubmit">
        <b-row>
          <b-col>
            <md-field :state="!form1.errors.has('email')" :class="form1.errors.get('email')?'haserror forstar':'forstar'"
                            :invalid-feedback="form1.errors.get('email')">
              <label>Email</label>
              <md-input v-model="form1.email" :state="!form1.errors.has('email')"
                                @input="form1.errors.clear('email')" type="text"></md-input>
              <span class="error-msg" v-if="form1.errors.get('email')">{{form1.errors.get('email')}}</span>
            </md-field>
          </b-col>
        </b-row>
       
        <b-button type="submit" class="reset_button" block variant="dark">Request New Password</b-button>
        <span class="success" v-if="this.successMessage">{{this.successMessage}}</span>
      </form>
    </b-modal>
    <div class="login">
      <b-jumbotron class="pl-0 pr-0" container-fluid="true" bg-variant="white">
        <b-container fluid>
          <b-row>
            <b-col>
              <div class="login-form">
                <h1>Sign in to RM COCO</h1>
                <div class="sign_up">
                  <b-form class="commonform" @submit="onSubmit">
                    <b-row>
                      <b-col>
                        <md-field :state="!form.errors.has('username')" :class="form.errors.get('username')?'haserror':''"
                            :invalid-feedback="form.errors.get('username')">
                          <label>Username</label>
                          <md-input v-model="form.username" :state="!form.errors.has('username')"
                                @input="form.errors.clear('username')"
                                autofocus type="text"></md-input>
                                <span class="error-msg" v-if="form.errors.get('username')">{{form.errors.get('username')}}</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :class="form.errors.get('password')?'haserror':''" :state="!form.errors.has('password')"
                            :invalid-feedback="form.errors.get('password')">
                          <label>Password</label>
                          <md-input v-model="form.password"
                          :state="!form.errors.has('password')"
                                @input="form.errors.clear('password')" type="password"></md-input>
                                <span class="error-msg" v-if="form.errors.get('password')">{{form.errors.get('password')}}</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-checkbox v-model="form.remember">Remember Me</md-checkbox>
                      </b-col>
                      <b-col>
                        <b-button
                          v-b-modal.modal-prevent-closing
                          class="forget_pass"
                        >Forgot password?</b-button>
                      </b-col>
                    </b-row>
                    <b-button type="submit" block variant="dark">Sign In</b-button>
                  </b-form>
                </div>
                <div class="help_signup">
                  <p>Need Help with Sign in?</p>
                  <p>&nbsp;</p>
                  <p>Email <a href="mailto:websupport@rmcoco.com">websupport@rmcoco.com</a></p>
                  <p>&nbsp;</p>
                  <p>Or call 1-800-325-8025</p>
                  <!--<b-button href="/shop/contact" block variant="outline-primary" squared>Contact Us</b-button>-->
                </div>
              </div>
            </b-col>
            <b-col class="pr-0 pl-0" cols="5">
              <b-img src="/shop/images/siginimage.jpg" fluid alt="Fluid image"></b-img>
              <div class="signin_div">
                <h1>Request an Account!</h1>
                <b-button href="/shop/online-application-form" block variant="dark">Online Application</b-button>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-jumbotron>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import AuthMixin from "../../mixins/auth";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";

export default {
  components: {
    CommonHead,
    CommonFoot
  },
  metaInfo: {
    title: 'RM COCO | Sign In',
    meta: [{
      name: 'description',
      content: 'Sign into RMCOCO.com to access your account and view pricing. Forgot your password? Reset it here.'
    }],
  },
  mixins: [AuthMixin],
  data() {
    return {
      form: new Form({
        username: "",
        password: "",
        remember: false,
        name: "",
        nameState: null
      }),
      form1: new Form({
        email: ""
      }),
      isLoading: false,
      successMessage:''
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.login();
      //alert(JSON.stringify(this.form));
    },
    login() {
      this.isLoading = true;
      this.$store
        .dispatch("login", this.form)
        .then(() => {
          var referrer=document.referrer;
          let redirect = this.$route.query.redirect;
          if (redirect !== undefined) {
            this.redirectAfterLogin();
          }else if(referrer){	
            window.location.href=referrer;
          }else{
            window.location.href="/shop/account";
          }
          this.isLoading = false;
        })
        .catch(error => {
        if (this.form.hasErrors()) {
          this.$notify({
            text:
              "These credentials do not match our records.",
            type: "error"
          });
        } else {
          this.$notify({
            text: "Something went wrong!",
            type: "error"
          });
        }
        this.isLoading = false;
      });
    },
    forgotPassword() {
     // evt.preventDefault();
      this.isLoading = true;
      this.$store.dispatch("forgotPassword", this.form1).then(response => {
        if (response.data.success) {
          this.$notify({
            text: response.data.message,
            type: "success"
          });
          $(".reset_button").text('Resend');
          $(".reset_title").text('Didn’t get the message?');

          this.successMessage="we have sent a recovery email to "+this.form1.email+". Check your inbox and follow the link to verify your address.";
          // this.form1 = new Form({
          //   email: null
          // });
        } else {
          this.$notify({
            text: response.data.message,
            type: "error"
          });
        }
      });
      this.isLoading = false;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },
    resetModal() {
      this.name = "";
      this.nameState = null;
      //$(".reset_button").text('Request New Password');
      //$(".reset_title").text('Forgot Password');

      this.form1.email='';
      this.successMessage="";

    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      //this.submittedNames.push(this.name);
      
      this.forgotPassword();
      // Hide the modal manually
      // this.$nextTick(() => {
      //   this.$bvModal.hide("modal-prevent-closing");
      // });
    }
  }
};
</script>
<style>
.login {
  width: 100%;
  overflow: hidden;
}
.login .bg-white {
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 0;
}
.login .img-fluid {
  height: 1045px;
  object-fit: cover;
  width: 100%;
}
.login .login-form {
  max-width: 420px;
  float: right;
  width: 100%;
  margin-right: 280px;
}
.login .login-form h1 {
  margin-top: 110px;
  display: inline-block;
  width: 100%;
  margin-bottom: 30px;
  line-height: 32px;
}
.login .pr-0.col-5.pl-0 {
  max-width: 43.5%;
  flex: 0 0 43.5%;
}
/* .login .md-field.md-has-password .md-toggle-password {
  display: none;
}
.login .md-checkbox .md-checkbox-container {
  border-color: #d2d2d2;
}
.login .md-checkbox {
  margin: 14px 0 0 0;
}
.login .md-checkbox.md-theme-default .md-checkbox-container {
  border-width: 1px;
  border-color: #d2d2d2;
}
.login .md-checkbox .md-checkbox-container:hover {
  border-color: #191919;
}
.login .md-checkbox.md-theme-default.md-checked .md-checkbox-container {
  background-color: #ececec;
}
.login .md-checkbox.md-theme-default.md-checked .md-checkbox-container {
  border-color: #191919;
}
.login .md-checkbox.md-theme-default.md-checked .md-checkbox-container:after {
  border-color: #191919;
}
.login .md-checkbox .md-checkbox-container:after {
  top: 1px;
  left: 6px;
} */
.md-theme-default .login-form .sign_up .forget_pass {
  float: right;
  margin: 15px 0 25px 0;
  color: #303030;
  /* text-decoration: underline; */
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  padding-bottom: 0;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #303030;
  border-radius: 0;
  padding: 0;
}
.md-theme-default .login-form .sign_up .forget_pass:hover {
  text-decoration: none;
  text-shadow: 0px 0px 1px #303030;
}
#app .sign_up .md-checkbox {
  margin: 15px 0 0 0;
}
.login .md-checkbox .md-checkbox-label {
  color: #303030;
  font-weight: 400;
  font-size: 14px;
}
.modal-backdrop {
  background: rgba(0, 0, 0, 0.5);
}
.common_pop .modal-dialog.modal-md {
  max-width: 440px;
  margin-top: 27.5rem;
}
.common_pop .modal-header .close {
  font-size: 24px;
  padding: 0;
  margin: 0;
  font-weight: normal;
  color: #303030;
  opacity: 1;
  position: absolute;
  right: 25px;
  top: 20px;
}
.common_pop .modal-dialog.modal-md .modal-header {
  border-bottom: 0;
}
.common_pop .modal-dialog.modal-md .modal-header h3 {
  font-size: 16px;
  text-align: center;
  display: inline-block;
  width: 100%;
  font-weight: 500;
  color: #303030;
}
.common_pop .modal-dialog.modal-md .modal-content {
  padding: 20px 40px 40px 40px;
  box-sizing: border-box;
}
.common_pop .modal-dialog.modal-md .modal-footer {
  display: none;
}
.common_pop span.success{
  width: 100%;
  position: relative;
  margin-top: 10px;
  display: inline-block;
  color: #303030;
}
@media only screen and (max-width: 1440px) and (min-width: 1280px) {
  .login .login-form {
    margin-right: 200px;
  }
}
@media only screen and (max-width:1024px) and (min-width:768px){
	.container, header .container {
		max-width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
	}
	.login .pr-0.col-5.pl-0 {
		max-width: 100%;
		-webkit-box-flex: 0;
		flex: 100%;
	}
	span.error-msg{
		font-size:12px;
	}
	.login .login-form {
		max-width: 420px;
		float: none;
		width: 100%;
		margin: 0 auto;
	}
}
@media only screen and (max-width:767px){
	.login .pr-0.col-5.pl-0 {
		max-width: 100%;
		-webkit-box-flex: 0;
		flex: 100%;
	}
	span.error-msg{
		font-size:12px;
	}
	.login .login-form {
		max-width: 100%;
		float: none;
		width: 100%;
		margin-right: 0;
	}
}
</style>